export const formatPrice = (amount: number, currency: string) =>
  new Intl.NumberFormat('fr-BE', { style: 'currency', currency }).format(amount)
